import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { NarrativeModuleFragment } from "./NarrativeModule.fragment";
import { NarrativeModuleLayout } from "./NarrativeModuleLayout";
export function NarrativeModule(t0) {
  const $ = _c(4);
  const {
    module: moduleKey
  } = t0;
  let t1;
  if ($[0] !== moduleKey) {
    t1 = readFragment(NarrativeModuleFragment, moduleKey);
    $[0] = moduleKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const moduleData = t1;
  let t2;
  if ($[2] !== moduleData) {
    t2 = <NarrativeModuleLayout {...moduleData} />;
    $[2] = moduleData;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}